export const youtube = 'https://www.youtube.com/embed/';
export const instagramprofile = 'https://www.instagram.com/p/';
export function addStrings(x: string,y: string): string {
    return x+y;
}
export function createYoutube(y: string): string {
    return youtube+y;
}